// extracted by mini-css-extract-plugin
export default {"profileDropdownMenu":"UserProfileMenu_profileDropdownMenu__doJ0x"};